import styled from 'styled-components';
import {NavLink, TabContent} from 'reactstrap';

export const ToolTip = styled.i`
  position: relative;
  display: inline-block;
  z-index: 2;
  font-weight: 300;
  font-family: "Font Awesome 5 Pro" !important;
  &:hover {
      cursor: pointer;
  }
  &:hover .tooltiptext {
      visibility: visible;
  }
`;

export const ToolTipText = styled.span`
  visibility: hidden;
  width: 150px;
  background-color: #2E394F;
  color: #fff;
  font-size: 12px;
  text-align: center;
  border-radius: 5px;
  padding: 6px 0;
  position: absolute;
  bottom: 127%;
  left: 50%;
  margin-left: -75px;
  &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: #2E394F transparent transparent transparent;
  }
`;
